import { Student } from '@/interfaces/student.interface';
import { Types } from 'mongoose';
import { API } from './api.class';
import { GetStudentStatsRequestDto } from '@/classes/dto/student-handler/request/GetStudentStats.request.dto';
import { GetStudentStatsResponseDto } from '@/classes/dto/student-handler/response/GetStudentStats.response.dto';
import {CreateStudentRequestDto} from '@/classes/dto/student-handler/request/CreateStudent.request.dto';
import {FindStudentRequestDto} from '@/classes/dto/student-handler/request/FindStudent.request.dto';
import {UpdateStudentRequestDto} from '@/classes/dto/student-handler/request/UpdateStudent.request.dto';
import { FindByIdOptionsRequestDto } from '@/classes/dto/_common/request/FindByIdOptions.request.dto';
import {DeactivationRequestDto} from '@/classes/dto/_common/request/Deactivation.request.dto';
import {ActivationRequestDto} from '@/classes/dto/_common/request/Activation.request.dto';
import {SendCommonCustomerMailRequestDto} from '@/classes/dto/student-handler/request/SendCommonCustomerMail.request.dto';
import {UpdateStudentClassResponseDto} from "@/classes/dto/student-handler/response/UpdateStudentClassResponseDto";
import {MailReportResponseDto} from "@/classes/dto/_common/response/mailReport.response.dto";
/**
 * This class is used for communicating with StudentHandler microservice
 * @class StudentHandlerApi
 * @author mklaczinski
 */
export class StudentHandlerApi extends API {
    static service = 'student-handler';

    static async create(newDocument: CreateStudentRequestDto): Promise<Student> {
        return this.post(``, newDocument);
    }
    static async sendCommonMail(data: SendCommonCustomerMailRequestDto): Promise<MailReportResponseDto> {
        return this.post(`common-mail`, data);
    }
    static async update(id: Types.ObjectId, updateQuery: UpdateStudentRequestDto): Promise<void> {
        return this.put(`${id}`, updateQuery);
    }
    static async getStats(data: GetStudentStatsRequestDto): Promise<GetStudentStatsResponseDto> {
        return this.get('stats', data);
    }
    static async getCanUpdateRelated(id: Types.ObjectId): Promise<boolean> {
        return this.get(`canUpdateRelated/${id}`);
    }
    static async find(findQuery: FindStudentRequestDto): Promise<{ students: Student[]; maxPage: number }> {
        return this.get(``, findQuery);
    }
    static async findById(id: Types.ObjectId | string, options?: FindByIdOptionsRequestDto): Promise<Student> {
        return this.get(`${id}`, options);
    }
    static async deactivate(id: Types.ObjectId, data: DeactivationRequestDto): Promise<void> {
        return this.put(`deactivate/${id}`, data);
    }
    static async reactivate(id: Types.ObjectId, data: ActivationRequestDto): Promise<void> {
        return this.put(`reactivate/${id}`, data);
    }
    static async remove(id: Types.ObjectId): Promise<void> {
        return this.delete(`${id}`);
    }
    static async updateClass(id: Types.ObjectId ): Promise<UpdateStudentClassResponseDto>{
        return this.get(`updateClass/${id}`);
    }
}
